<template>
	<v-col class="ma-0 pa-0" cols="12" id="head_title">
		<v-col class="pa-0" cols="12" id="main_content_maxwidthset">
			<v-row class="ma-0 pa-0" align="center" justify="space-between" id="header_height">
				<v-row class="ma-0 pa-0" align="center">
					<v-btn width="9rem" height="50px" class="ma-0 pa-0" 
						id="header_btn1" elevation="0" @click="goGroupDetail"
						:class="{'current_btn': currentRoute == 'groupDetail' }">
						{{tsg('storeList')}}
					</v-btn>
					<v-btn width="9rem" height="50px" class="ma-0 pa-0" 
						id="header_btn2" elevation="0" @click="goSplitScreen"
						v-if="authorities.GET_RECORDING_SUB_BRANCH"
						:class="{'current_btn': currentRoute == 'splitScreenViewSelect' || 
							currentRoute == 'splitScreenCameraSelect' || 
							currentRoute == 'splitScreen' }">
						{{tsg('splitScreen')}}
					</v-btn>
					<v-btn width="9rem" height="50px" class="ma-0 pa-0" 
						id="header_btn3" elevation="0" @click="goCCTVCameraList"
						v-if="authorities.GET_RECORDING_SUB_BRANCH"
						:class="{'current_btn': currentRoute == 'cctvCameraList' || 
							currentRoute == 'cctvSearch' || 
							currentRoute == 'cctvCameraListView' }">
						{{tsg('cameraList')}}
					</v-btn>
				</v-row>
				<v-row class="ma-0 pa-0" align="center" justify="end"
					v-if="authorities.ADD_STORE_GROUP">
					<v-btn width="auto" height="50px" class="back_clean_btn ma-0 pa-0 pl-1 pr-1" 
						id="back_clean_btn1" elevation="0" @click="groupEditDialogVisible = true">
						<v-row class="ma-0 pa-0" align="end">
							<v-img max-height="2rem" max-width="2rem" class="ma-0 pa-0"
								src="@/assets/images/icon_store.png"></v-img>
							<v-col class="ma-0 pa-0 pl-1" cols="auto"
								style="color: #979FB1;">
								{{storeCount + tsg('store') + ' / ' + tsg('camera') + cameraCount + t('ea')}}
							</v-col>
							<v-img max-height="1rem" max-width="1rem" class="ma-0 pa-0"
								src="@/assets/images/corner_bottom_arrow.png"></v-img>
						</v-row>
					</v-btn>
					<v-btn width="auto" height="50px" class="back_clean_btn ma-0 pa-0 pl-1 pr-1 ml-5" 
						id="back_clean_btn2" elevation="0" @click="shareUserDialogVisible = true">
						<v-row class="ma-0 pa-0" align="end">
							<v-img max-height="1.5rem" max-width="1.25rem" class="ma-0 pa-0"
								src="@/assets/images/icon_user.png"></v-img>
							<v-col class="ma-0 pa-0 pl-1" cols="auto"
								style="color: #979FB1;">
								{{t('total') + shareUserCount + t('peopleInTotal')}}
							</v-col>
							<v-img max-height="1rem" max-width="1rem" class="ma-0 pa-0"
								src="@/assets/images/corner_bottom_arrow.png"></v-img>
						</v-row>
					</v-btn>
					<v-menu offset-y>
      			<template v-slot:activator="{ on, attrs }">
							<v-btn width="auto" height="50px" class="back_clean_btn ma-0 pa-0 pl-1 pr-1 ml-5" 
								id="back_clean_btn3" elevation="0" v-bind="attrs" v-on="on">
								<v-img max-height="1.75rem" max-width="1.75rem" class="ma-0 pa-0"
									src="@/assets/images/cog_corner_arrow.png"></v-img>
							</v-btn>
						</template>
						<v-list class="ma-0 pa-0">
							<v-list-item class="ma-0 pa-2" @click="editGroupNameDialogVisible = true"
							  style="border-bottom: 1px solid #4A4A4A;">
								<v-list-item-title class="list_font">{{tsg('renameTheGroup')}}</v-list-item-title>
							</v-list-item>
							<v-list-item class="ma-0 pa-2" @click="requestDeleteStoreGroup"
								 style="border-bottom: 1px solid #4A4A4A;">
								<v-list-item-title class="list_font">{{tsg('removeGroup')}}</v-list-item-title>
							</v-list-item>
							<v-list-item class="ma-0 pa-2" @click="requestChangeLabel">
								<v-list-item-title class="list_font">{{tsg('changeLabel')}}</v-list-item-title>
							</v-list-item>
						</v-list>
					</v-menu>
				</v-row>
			</v-row>
		</v-col>

		<GroupEditDialog :dialogVisible="groupEditDialogVisible" :fromHeader="true"
			:group="currentGroup" @update="storesUpdate"
      @visible="groupEditDialogVisibleFunc" />
		<ShareUserDialog :dialogVisible="shareUserDialogVisible"
      @visible="shareUserDialogVisibleFunc" :group="currentGroup"
			@update="shareUserUpdate" />
		<EditGroupNameDialog :dialogVisible="editGroupNameDialogVisible"
      @visible="editGroupNameDialogVisibleFunc" @success="groupNameChangeSuccessFunc" />
		<LabelChangeDialog :dialogVisible="labelChangeDialogVisible" @update="labelUpdateFunc"
      @visible="labelChangeDialogVisibleFunc" />
	</v-col>
</template>

<script>
import mixin from '@/mixin';
import GroupEditDialog from '@/components/dialogs/GroupEditDialog.vue';
import ShareUserDialog from '@/components/dialogs/ShareUserDialog.vue';
import EditGroupNameDialog from './components/EditGroupNameDialog.vue'
import LabelChangeDialog from '@/components/dialogs/LabelChangeDialog.vue';
export default {
	components: {
		GroupEditDialog, ShareUserDialog, EditGroupNameDialog, LabelChangeDialog
	},
	mixins: [mixin.common],
	data: () => ({
		currentGroupId: '',
		currentGroup: null,
		authorities: {},
		currentRoute: '',
    groupEditDialogVisible: false,
		shareUserDialogVisible: false,
		editGroupNameDialogVisible: false,
		labelChangeDialogVisible: false,
		storeCount: 0,
		cameraCount: 0,
		shareUserCount: 0,
    deviceStatusList: ['5', '10', '12', '17', '19', '20'],
	}),
	watch: {
		groupEditDialogVisible () {
			this.getStores();
		},
		$route: {
      immediate: true,
      handler(to, from) {
        this.currentGroupId = to.query.groupId;
        this.currentRoute = to.name;
				this.fetchGroupData();
				this.getStores();
      }
    },
		'$store.state.userData.storeGroupList': {
      deep: true,
      handler(val, oldVal) {
        let currentGroupIndex = val.findIndex(r => r.id === this.currentGroupId);
        if(currentGroupIndex != -1) {
				  this.currentGroup = val[currentGroupIndex];
				  this.storeCount = val[currentGroupIndex].stores.length.toString();
          if(val[currentGroupIndex].sharedUsers != undefined)
				    this.shareUserCount = val[currentGroupIndex].sharedUsers.length.toString();
        }
      }
    },
    storeCount: function() { //storeCount가 확정되었을 때 정보 전달
			this.$emit('currentGroup', this.currentGroup);
    }
	},
	created() {
		this.currentRoute = this.$route.name;
		this.currentGroupId = this.$route.query.groupId;
		this.authorities = this.$store.getters.getAuthorities;
		// console.log('%cCurrent Store Group\n', "color:#008DD0;", this.currentGroup);
	},
	mounted() {
		 
	},
	methods: {
		tsg(t) {
      return this.$t("lang.group." + t);
    },
		fetchGroupData() {
			this.fetchLoading = true;
			let params = {};
			this.networkController.getStoreGroupDetail(params, this.currentGroupId)
			.then(async (res) => {
				console.log('%cFetch Store Group Detail\n', "color:#008DD0;", res.data);
				this.currentGroup = res.data;
				this.storeCount = this.currentGroup.stores.length.toString();
				if(this.currentGroup.sharedUserStoreGroups != undefined) {
				  this.shareUserCount = this.currentGroup.sharedUserStoreGroups.length.toString();
				}
			}).catch(error => { });
		},
		async getStores() {
			try {
				const { data: stores } = await this.networkController.getStoresByStoreGroup({}, this.currentGroupId);
				this.$emit('currentStores', stores);
				this.cameraCount = 0; 
				
				stores.forEach((store, index)=>{
					let storeCamerasList = []; //isUas가 true인 카메라 제거를 위한 빈 배열
					
					store.storeCameras.forEach((camera)=>{
						if(camera.isOnline == false) { 
							let cameraData = camera; // ?? 
					  	cameraData.streamAble = false;
						}else{
							let cameraData = camera;
					  	cameraData.streamAble = true;
					  	storeCamerasList.push(cameraData);
              this.cameraCount++;
						}						
					})
					
					stores[index].storeCameras = storeCamerasList;
				})
				this.fetchLoading = false;
			} catch(error) {
				console.error(error)
				this.fetchLoading = false;
			}
		},
		fetchStoreGroupList() {
			let params = {};
			this.networkController.getStoreGroupAllData(params).then(async (res) => {
				console.log('%cFetch Store Group List\n', "color:#008DD0;", res.data);
				let userStoreGroupList = res.data;
				await this.$store.commit('setStoreGroupList', userStoreGroupList);
			}).catch(error => { });
		},
		goGroupDetail() {
			this.pushRoute('/store-group/detail', { groupId: this.currentGroupId });
		},
		async goSplitScreen() {
      let params = {};
      await this.networkController.getCameraSplitList(params, this.currentGroupId).then(async (res) => {
        console.log('%cFetch Split Screen Data\n', "color:#008DD0;", res.data);
        if(res.data.length ==0)
          this.pushRoute('/split-screen/view-select', {groupId: this.currentGroupId});
        else
          this.pushRoute('/split-screen/viewer', {groupId: this.currentGroupId});
        this.fetchLoading = false;
      }).catch(error => {
        this.fetchLoading = false;
      });
		},
		async goCCTVCameraList() {
			let params = {};
			await this.networkController.getStoreGroupCameraList(params, this.currentGroupId).then(async (res) => {
				console.log('%cFetch Group Camera Detail\n', "color:#008DD0;", res.data);
        this.pushRoute('/store-group/camera-list/view', { groupId: this.currentGroupId });
				this.fetchLoading = false;
			}).catch(error => {
				this.fetchLoading = false;
			});
		},
		groupEditDialogVisibleFunc(visible) {
      this.groupEditDialogVisible = visible;
    },
		shareUserDialogVisibleFunc(visible) {
      this.shareUserDialogVisible = visible;
    },
		editGroupNameDialogVisibleFunc(visible) {
      this.editGroupNameDialogVisible = visible;
    },
		groupNameChangeSuccessFunc(status) {
			if(status) this.fetchStoreGroupLabel();
		},
		labelChangeDialogVisibleFunc(visible) {
      this.labelChangeDialogVisible = visible;
    },
		labelUpdateFunc(value) {
			this.fetchStoreGroupLabel();
		},
		async requestDeleteStoreGroup() {
			await this.$dialog.confirm({
				title: this.tcb('deleteGroupTitle'),
				text: this.tcb('storeGroupDeleteCheck'),
				actions: {
					false: { color: 'white', text: this.t('cancel'),},
					true: {
						color: '#008DD0', text: this.t('confirm'),
						handle: async () => {
							this.$vloading.show();
							let params = {};
							await this.networkController.deleteStoreGroup(params, this.currentGroupId)
							.then(async (res) => {
								let oldStoreGroupList = this.$store.getters.getStoreGroupList;
								let currentGroupIndex = oldStoreGroupList.findIndex(r => r.id === this.$route.query.groupId);
								await oldStoreGroupList.splice(currentGroupIndex, 1);
								await this.$store.commit('setStoreGroupList', oldStoreGroupList);
								this.fetchStoreGroupLabel();
								this.$vloading.hide();
								this.showToastMessage(this.tmb('requestSuccess'));
								this.replaceRoute("/dashboard", {});
							}).catch(error => {
								this.$vloading.hide();
							});
						}
					}
				}
			});
		},
		requestChangeLabel() {
			this.labelChangeDialogVisible = true;
		},
		shareUserUpdate(group) {
			this.currentGroup = group;
			this.shareUserCount = group.sharedUserStoreGroups.length.toString();
		},
		storesUpdate(group) {
			this.currentGroup = group;
			this.storeCount = group.stores.length.toString();
			this.$emit('currentStore', group.id);
		},
		fetchStoreGroupLabel() {
			const params = {};
			this.networkController.getStoreGroupLabel(params).then(async (res) => {
				console.log('%cFetch Store Group Label\n', "color:#008DD0;", res.data);
				this.$store.commit('setStoreGroupLabel', res.data);
			}).catch(error => { });
		},
	}
}
</script>

<style lang="scss" scoped>
#head_title {
	position: sticky;
	top: 0;
	z-index: 5;
	background-color: #272A33;
}
#header_height {
	height: 50px;
}
#header_btn1 {
	color: #979FB1;
	border-bottom: 1px solid #484848;
	background-color: transparent;
	min-width: 1rem;
}
#header_btn2 {
	color: #979FB1;
	border-bottom: 1px solid #484848;
	background-color: transparent;
	min-width: 1rem;
}
#header_btn3 {
	color: #979FB1;
	border-bottom: 1px solid #484848;
	background-color: transparent;
	min-width: 1rem;
}
.current_btn {
	color: white !important;
	background-color: transparent;
	min-width: 1rem;
	border-bottom: 4px solid #008DD0 !important;
}
.back_clean_btn {
	background-color: transparent !important;
	min-width: 1rem;
	color: white;
}
.list_font {
	font-size: 0.8rem;
	font-weight: bold;
}
.v-list {
  background: #171921 !important;
	border: 1px solid #4A4A4A;
}
::v-deep {
  .v-list-item{
    min-height: 0px;
    color: white !important;
  }
  .v-list-item__content{
    color: white;
    padding: 5px 0;
  }
}
</style>